/** @format */

//

// 车场业态字典项枚举,00：商业、01：住宅、02：机场、03：写字楼、04:交通枢纽
// 停车场业态  01为居民小区、02为商圈停车场、03为路侧停车、04为公园景点、
// 05为商务楼宇、06为其他、07为交通枢纽、08为市政设施
export enum DictParkType {
  // Business = '00',
  House = '01',
  Airport = '02',
  OfficeBuilding = '03',
  TransportationHub = '04',
  commercial = '05',
  other = '06',
  transportation = '07',
  facilities = '08'
}
export const dictParkTypeMap: {
  [key: string]: string;
} = {
  // [DictParkType.Business]: '商业',
  [DictParkType.House]: '居民小区',
  [DictParkType.Airport]: '商圈停车场',
  [DictParkType.OfficeBuilding]: '路侧停车',
  [DictParkType.TransportationHub]: '公园景点',
  [DictParkType.commercial]: '商务楼宇',
  [DictParkType.other]: '其他',
  [DictParkType.transportation]: '交通枢纽',
  [DictParkType.facilities]: '市政设施'
};
// 运营状态,多个逗号分隔   01：正式运营 02：试运营 03：已停用 04：未接入
export enum DictoperationState {
  official = '01',
  trial = '02',
  discontinued = '03',
  Noaccess = '04'
}
export const dictoperationStateMap: {
  [key: string]: string;
} = {
  [DictoperationState.official]: '正式运营',
  [DictoperationState.trial]: '试运营',
  [DictoperationState.discontinued]: '已停用',
  [DictoperationState.Noaccess]: '未接入'
};
// 在线状态字典项枚举,00 离线  01：在线  02：未接入
export enum DictConnectStatus {
  Offline = '00',
  Online = '01'
  // Unconnected = '02',
}
export const dictConnectStatusMap: {
  [key: string]: string;
} = {
  [DictConnectStatus.Offline]: '离线',
  [DictConnectStatus.Online]: '在线'
  // [DictConnectStatus.Unconnected]: '未接入',
};
// 边缘服务提供商 01:众畅 02:通通 03:零壹 04:捷顺 05:欧冠 06:科拓 07:蓝卡
export enum DictEdgeServiceProvider {
  zhongchang = '01',
  tongtong = '02',
  linyi = '03',
  jiwahun = '04',
  ouguan = '05',
  ketuo = '06',
  lanka = '07'
}
export const dictEdgeServiceProviderMap: {
  [key: string]: string;
} = {
  [DictEdgeServiceProvider.zhongchang]: '众畅',
  [DictEdgeServiceProvider.tongtong]: '通通',
  [DictEdgeServiceProvider.linyi]: '零壹',
  [DictEdgeServiceProvider.jiwahun]: '捷顺',
  [DictEdgeServiceProvider.ouguan]: '欧冠',
  [DictEdgeServiceProvider.ketuo]: '科拓',
  [DictEdgeServiceProvider.lanka]: '蓝卡'
};
// 时间对比字典项枚举, 00：本地慢 , 01：一致  02：本地快
export enum DictTimeCompare {
  LocalSlow = '00',
  AsFastAs = '01',
  LocalFast = '02'
}
export const dictTimeCompareMap: {
  [key: string]: string;
} = {
  [DictTimeCompare.LocalSlow]: '本地慢',
  [DictTimeCompare.AsFastAs]: '一致',
  [DictTimeCompare.LocalFast]: '本地快'
};

// 运营状态字典项枚举,（ 00：暂停 01：正常）
export enum DictOperateStatus {
  Pause = '00',
  Normal = '01'
}
export const dictOperateStatusMap: {
  [key: string]: string;
} = {
  [DictOperateStatus.Pause]: '暂停',
  [DictOperateStatus.Normal]: '正常'
};

// 是否独立计费字典项枚举,（00:不需要  01:需要）
export enum DictAlonePay {
  No = '00',
  Yes = '01'
}
export const dictAlonePayMap: {
  [key: string]: string;
} = {
  [DictAlonePay.Yes]: '是',
  [DictAlonePay.No]: '否'
};
// 是否独立计费字典项枚举,（00:是  01:否）
export enum DictfeiPay {
  No = '01',
  Yes = '00'
}
export const dictfeiPayMap: {
  [key: string]: string;
} = {
  [DictfeiPay.Yes]: '是',
  [DictfeiPay.No]: '否'
};

// 是否独立计费字典项枚举,（00:不需要  01:需要）
export enum DictIsAlonePay {
  All = '',
  Yes = '00',
  No = '01'
}
export const dictIsAlonePayMap: {
  [key: string]: string;
} = {
  [DictIsAlonePay.All]: '全部',
  [DictIsAlonePay.Yes]: '是',
  [DictIsAlonePay.No]: '否'
};

// 满位是否允许进入 00：不允许 01：允许
export enum DictIsNoCar {
  All = '',
  Yes = '01',
  No = '00'
}
export const dictIsNoCarMap: {
  [key: string]: string;
} = {
  [DictIsNoCar.All]: '全部',
  [DictIsNoCar.Yes]: '是',
  [DictIsNoCar.No]: '否'
};

//设备类型01:车牌识别相机 02:LED显示屏 03:道闸设备 04:语音设备
// 05:车位诱导设备 06:车位引导屏 99: 其他
export enum DictDeviceType {
  Camera = '01',
  LED = '02',
  Barrier = '03',
  Voice = '04',
  ParkingSpaceGuidanceDevice = '05',
  ParkingSpaceGuidanceScreen = '06',
  Other = '99'
}
export const dictDeviceTypeMap: {
  [key: string]: string;
} = {
  [DictDeviceType.Camera]: '车牌识别相机',
  [DictDeviceType.LED]: 'LED显示屏',
  [DictDeviceType.Barrier]: '道闸设备',
  [DictDeviceType.Voice]: '语音设备',
  [DictDeviceType.ParkingSpaceGuidanceDevice]: '车位诱导设备',
  [DictDeviceType.ParkingSpaceGuidanceScreen]: '车位引导屏',
  [DictDeviceType.Other]: '其他'
};

// 运行状态字典项枚举,( 00 ：离线 01 : 正常  02：故障)
export enum DictDeviceStatus {
  Offline = '00',
  Normal = '01',
  Fault = '02'
}
export const dictDeviceStatusMap: {
  [key: string]: string;
} = {
  [DictDeviceStatus.Offline]: '离线',
  [DictDeviceStatus.Normal]: '正常',
  [DictDeviceStatus.Fault]: '故障'
};

// 通道类型字典项枚举, 通道类型 00 ：入场 01 ： 出场
export enum DictChannelType {
  Entrance = '00',
  Exit = '01'
}
export const dictChannelTypeMap: {
  [key: string]: string;
} = {
  [DictChannelType.Entrance]: '入口',
  [DictChannelType.Exit]: '出口'
};

/**
 * 区域相关字段
 */

// 区域-运营类型  01：开发商委托 02：业委会委托 03：小业主委托 04：自有停车场
export enum DictOperationType {
  DeveloperEntrust = '01',
  IndustryEntrust = '02',
  SmallProprietorCommission = '03',
  OwnedCarPark = '04'
}
export const dictOperationTypeMap: {
  [key: string]: string;
} = {
  [DictOperationType.DeveloperEntrust]: '开发商委托',
  [DictOperationType.IndustryEntrust]: '业委会委托',
  [DictOperationType.SmallProprietorCommission]: '小业主委托',
  [DictOperationType.OwnedCarPark]: '自有停车场'
};

// 区域属性
export enum DictProperty {
  Ground = '00',
  Basement = '01'
}
export const dictPropertyMap: {
  [key: string]: string;
} = {
  [DictProperty.Ground]: '地面',
  [DictProperty.Basement]: '地库'
};

// 区域-车位录入方式  01：手动录入 02：根据车位资源自动计算
export enum DictTypeIn {
  Manual = '01',
  Automatic = '02'
}
export const dictTypeInMap: {
  [key: string]: string;
} = {
  [DictTypeIn.Manual]: '手动录入',
  [DictTypeIn.Automatic]: '根据车位资源自动计算'
};

// 满位是否允许进入 00：不允许 01：允许
export enum DictAllowableChannelType {
  notAllow = '00',
  allow = '01'
}
export const dictAllowableChannelTypeMap: {
  [key: string]: string;
} = {
  [DictAllowableChannelType.allow]: '是',
  [DictAllowableChannelType.notAllow]: '否'
};

// 车场管理-岗停信息
export enum DictGangStopType {
  'A' = '0',
  'B' = '1',
  'C' = '2'
}
export const dictGangStopTypeMap: {
  [key: string]: string;
} = {
  [DictGangStopType.A]: '全部',
  [DictGangStopType.B]: '普通岗停',
  [DictGangStopType.C]: '中央岗停'
};
// 运行状态字典项枚举,使用状态( 全部  启用 ：禁用) 使用状态:01生效，00无效，02全部
export enum DictuserMode {
  All = '02',
  StartUsing = '01',
  Forbidden = '00'
}
export const dictuserModeMap: {
  [key: string]: string;
} = {
  [DictuserMode.All]: '全部',
  [DictuserMode.StartUsing]: '启用',
  [DictuserMode.Forbidden]: '禁用'
};
// 设备状态 01：正常 00：异常 02全部
export enum DictEquipmentStatusMode {
  abnormal = '00',
  normal = '01',
  all = '',
  no = '02'
}
export const dictEquipmentStatusModeMap: {
  [key: string]: string;
} = {
  [DictEquipmentStatusMode.all]: '全部',
  [DictEquipmentStatusMode.normal]: '正常',
  [DictEquipmentStatusMode.abnormal]: '异常',
  [DictEquipmentStatusMode.no]: '离线'
};

// 设备品牌 01海康 02大华 03文通 04臻识 05华夏 06立方 07立林 08科拓 09富士 10欧冠 11真地 12：威视
export enum DictBrandMode {
  haikang = '01',
  dahua = '02',
  wentong = '03',
  zhengzhi = '04',
  huaxia = '05',
  lifang = '06',
  liling = '07',
  ketuo = '08',
  fushi = '09',
  ouguan = '10',
  zhengdi = '11',
  weishi = '12'
}
export const dictBrandMap: {
  [key: string]: string;
} = {
  [DictBrandMode.haikang]: '海康',
  [DictBrandMode.dahua]: '大华',
  [DictBrandMode.wentong]: '文通',
  [DictBrandMode.zhengzhi]: '臻识',
  [DictBrandMode.huaxia]: '华夏',
  [DictBrandMode.lifang]: '立方',
  [DictBrandMode.liling]: '立林',
  [DictBrandMode.ketuo]: '科拓',
  [DictBrandMode.fushi]: '富士',
  [DictBrandMode.ouguan]: '欧冠',
  [DictBrandMode.zhengdi]: '真地',
  [DictBrandMode.weishi]: '威视'
};

// 设备连接方式  01：透传 02:RJ45 03:Internit网络通信 04: RS485 ,485通信
export enum DictDeviceConnectionType {
  transmission = '01',
  RJ = '02',
  Internit = '03',
  RS = '04'
}
export const dictDeviceConnectionMap: {
  [key: string]: string;
} = {
  [DictDeviceConnectionType.transmission]: '透传',
  [DictDeviceConnectionType.RJ]: 'RJ45',
  [DictDeviceConnectionType.Internit]: 'Internit网络通信',
  [DictDeviceConnectionType.RS]: 'RS485 ,485通信'
};
// 驱动版本号  海康相机 1000001 大华相机1000031 文通相机 1000061  臻识相机 1000091
// 华夏相机 1000121 立方相机 1000151 立林相机 1000181 科拓相机 1000211 富士相机 1000241
// 欧冠LED屏 2000001 真地LED屏 2000031 立方LED屏 2000061 文通LED屏 2000091 立林LED屏 2000021
// 欧冠道闸 3000001 自定义协议测试相机 4294967294 不存在的类型 4294967295
// export enum DictDriverNumMode {
//   haikang = '1000001',
//   dahua = '1000031',
//   wentong = '1000061',
//   zhengzhi = '1000091',
//   huaxia = '1000121',
//   lifang = '1000151',
//   liling = '1000181',
//   ketuo = '1000211',
//   fushi = '1000241',
//   ouguan = '2000001',
//   zhengdi = '2000031',
//   lifangled = '2000061',
//   wentongled = '2000091',
//   lilingled = '2000021',
//   ouguandaozha = '3000001',
//   zidingyi = '4294967294',
//   notype = '4294967295',
// }
// export const dictDriverNumMap: {
//   [key: string]: string
// } = {
//   [DictDriverNumMode.haikang]: '海康相机',
//   [DictDriverNumMode.dahua]: '大华相机',
//   [DictDriverNumMode.wentong]: '文通相机',
//   [DictDriverNumMode.zhengzhi]: '臻识相机',
//   [DictDriverNumMode.huaxia]: '华夏相机',
//   [DictDriverNumMode.lifang]: '立方相机',
//   [DictDriverNumMode.liling]: '立林相机',
//   [DictDriverNumMode.ketuo]: '科拓相机',
//   [DictDriverNumMode.fushi]: '富士相机',
//   [DictDriverNumMode.ouguan]: '欧冠LED屏',
//   [DictDriverNumMode.zhengdi]: '真地LED屏',
//   [DictDriverNumMode.lifangled]: '立方LED屏',
//   [DictDriverNumMode.wentongled]: '文通LED屏',
//   [DictDriverNumMode.lilingled]: '立林LED屏',
//   [DictDriverNumMode.ouguandaozha]: '欧冠道闸',
//   [DictDriverNumMode.zidingyi]: '自定义协议测试相机',
//   [DictDriverNumMode.notype]: '不存在的类型',
// }

// 同步状态: 00全部 01下发中 02下发成功 03下发失败
export enum DictsynchronousType {
  all = '00',
  ministry = '01',
  success = '02',
  error = '03'
}
export const dictsynchronousMap: {
  [key: string]: string;
} = {
  [DictsynchronousType.all]: '全部',
  [DictsynchronousType.ministry]: '下发中',
  [DictsynchronousType.success]: '下发成功',
  [DictsynchronousType.error]: '下发失败'
};
// 同步状态: 计费规则类型：01按时计费02分段计费03分时计费04按次计费
export enum DictBillingRule {
  hour = '01',
  mins = '02',
  hourMin = '03',
  rate = '04'
}
export const dictBillingRuleMap: {
  [key: string]: string;
} = {
  [DictBillingRule.hour]: '按时计费',
  [DictBillingRule.mins]: '分段计费',
  [DictBillingRule.hourMin]: '分时计费',
  [DictBillingRule.rate]: '按次计费'
};

// 设备型号
// 1000001:海康相机  1000031:大华相机  1000061:文通相机  1000091:臻识相机  1000120:华夏相机
// 1000121:富士8201相机  1000122:富士6201相机  1000151:立方相机  1000181:立林相机S1206
// 1000211:科拓相机  2000001:欧冠LED屏  2000011:威视LED屏   2000021:立林LED屏  2000031:真地LED屏
// 2000061:立方LED屏   2000091:文通LED屏  2000111:华睿致兴LED   3000001:欧冠道闸
// 4000001:华睿智兴智能钱箱    5000001:速通ETC天线    1100000:阿里云边缘相机    2100000:阿里云边缘LED
// 3100000:阿里云边缘道闸    0xFFFFFFFE:自定义协议测试相机     0xFFFFFFFF:不存在的类型

export enum DictUnitTypeMode {
  haikang = '1000001',
  dahua = '1000031',
  wentong = '1000061',
  zhishi = '1000091',
  huaxia = '1000120',
  fushi8201 = '1000121',
  fushi6201 = '1000122',
  lifang = '1000151',
  lilings1206 = '1000181',
  ketuo = '1000211',
  ouguan = '2000001',
  weishiled = '2000011',
  lilingled = '2000021',
  zhengdiled = '2000031',
  lifangled = '2000061',
  wentongled = '2000091',
  huaruiled = '2000111',
  ouguanled = '3000001',
  huaruizhi = '4000001',
  sutongetc = '5000001',
  alybianyuan = '1100000',
  alyled = '2100000',
  alydaozha = '3100000'
  // zidingyi = '0xFFFFFFFE',
  // bucuizai = '0xFFFFFFFF',
}
export const dictUnitTypeMap: {
  [key: string]: string;
} = {
  [DictUnitTypeMode.haikang]: '海康相机',
  [DictUnitTypeMode.dahua]: '大华相机',
  [DictUnitTypeMode.wentong]: '文通相机',
  [DictUnitTypeMode.zhishi]: '臻识相机',
  [DictUnitTypeMode.huaxia]: '华夏相机',
  [DictUnitTypeMode.fushi8201]: '富士8201相机',
  [DictUnitTypeMode.fushi6201]: '富士6201相机',
  [DictUnitTypeMode.lifang]: '立方相机',
  [DictUnitTypeMode.lilings1206]: '立林相机S1206',
  [DictUnitTypeMode.ketuo]: '科拓相机',
  [DictUnitTypeMode.ouguan]: '欧冠LED屏',
  [DictUnitTypeMode.weishiled]: '威视LED屏',
  [DictUnitTypeMode.lilingled]: '立林LED屏',
  [DictUnitTypeMode.zhengdiled]: '真地LED屏',
  [DictUnitTypeMode.lifangled]: '立方LED屏',
  [DictUnitTypeMode.wentongled]: '文通LED屏',
  [DictUnitTypeMode.huaruiled]: '华睿致兴LED',
  [DictUnitTypeMode.ouguanled]: '欧冠道闸',
  [DictUnitTypeMode.huaruizhi]: '华睿智兴智能钱箱',
  [DictUnitTypeMode.sutongetc]: '速通ETC天线',
  [DictUnitTypeMode.alybianyuan]: '阿里云边缘相机',
  [DictUnitTypeMode.alyled]: '阿里云边缘LED',
  [DictUnitTypeMode.alydaozha]: '阿里云边缘道闸'
  // [DictUnitTypeMode.zidingyi]: '自定义协议测试相机',
  // [DictUnitTypeMode.bucuizai]: '不存在的类型',
};

// 1000031  大华相机  1000061  文通相机  1000091  臻识相机
// 1000120  华夏相机 1000151  立方相机 1000181  立林相机 1000211  科拓相机
// 1000121 富士8201相机 2000001  欧冠LED屏 2000031  真地LED屏 2000061  立方LED屏
// 2000091  文通LED屏 2000021  立林LED屏 3000001  欧冠道闸 4294967294  自定义协议测试相机
// 4294967295  不存在的类型 1000241  芊熠相机 1000122  富士6201相机 2000011  威视LED
// 4000001  智能钱箱设备  2000111  华睿LED  1000001  海康相机
// 确定版本号
export enum DictDriverNumMode {
  haikang = '1000001',
  dahua = '1000031',
  wentong = '1000061',
  zhishi = '1000091',
  huaxia = '1000120',
  fushi8201 = '1000121',
  fushi6201 = '1000122',
  lifang = '1000151',
  lilings1206 = '1000181',
  ketuo = '1000211',
  ouguan = '2000001',
  weishiled = '2000011',
  lilingled = '2000021',
  zhengdiled = '2000031',
  lifangled = '2000061',
  wentongled = '2000091',
  huaruiled = '2000111',
  ouguanled = '3000001',
  huaruizhi = '4000001',
  sutongetc = '5000001',
  alybianyuan = '1100000',
  alyled = '2100000',
  alydaozha = '3100000',
  // zidingyi = '4294967294',
  // bucuizai = '4294967295',
  qianshuo = '1000241'
}
export const dictDriverNumMap: {
  [key: string]: string;
} = {
  [DictDriverNumMode.haikang]: '海康相机',
  [DictDriverNumMode.dahua]: '大华相机',
  [DictDriverNumMode.wentong]: '文通相机',
  [DictDriverNumMode.zhishi]: '臻识相机',
  [DictDriverNumMode.huaxia]: '华夏相机',
  [DictDriverNumMode.fushi8201]: '富士8201相机',
  [DictDriverNumMode.fushi6201]: '富士6201相机',
  [DictDriverNumMode.lifang]: '立方相机',
  [DictDriverNumMode.lilings1206]: '立林相机',
  [DictDriverNumMode.ketuo]: '科拓相机',
  [DictDriverNumMode.ouguan]: '欧冠LED屏',
  [DictDriverNumMode.weishiled]: '威视LED屏',
  [DictDriverNumMode.lilingled]: '立林LED屏',
  [DictDriverNumMode.zhengdiled]: '真地LED屏',
  [DictDriverNumMode.lifangled]: '立方LED屏',
  [DictDriverNumMode.wentongled]: '文通LED屏',
  [DictDriverNumMode.huaruiled]: '华睿LED',
  [DictDriverNumMode.ouguanled]: '欧冠道闸',
  [DictDriverNumMode.huaruizhi]: '智能钱箱设备',
  [DictDriverNumMode.sutongetc]: '速通ETC天线',
  [DictDriverNumMode.alybianyuan]: '阿里云边缘相机',
  [DictDriverNumMode.alyled]: '阿里云边缘LED',
  [DictDriverNumMode.alydaozha]: '阿里云边缘道闸',
  [DictDriverNumMode.qianshuo]: '芊熠相机'
  // [DictUnitTypeMode.zidingyi]: '自定义协议测试相机',
  // [DictUnitTypeMode.bucuizai]: '不存在的类型',
};
// 设备连接方式 授权星期,多个日期逗号拼接，如“1，2，3，4，5，6，7”
export enum DictWeekType {
  one = '1',
  two = '2',
  three = '3',
  four = '4',
  five = '5',
  six = '6',
  seven = '7'
}
export const dictWeekMap: {
  [key: string]: string;
} = {
  [DictWeekType.one]: '星期一',
  [DictWeekType.two]: '星期二',
  [DictWeekType.three]: '星期三',
  [DictWeekType.four]: '星期四',
  [DictWeekType.five]: '星期五',
  [DictWeekType.six]: '星期六',
  [DictWeekType.seven]: '星期日'
};

// 设备连接方式 授权星期 全部 1234567  工作日12345 周末67
export enum DictWeekDateType {
  all = '1,2,3,4,5,6,7',
  workday = '1,2,3,4,5',
  weekend = '6,7'
}
export const dictWeekDateMap: {
  [key: string]: string;
} = {
  [DictWeekDateType.all]: '全部',
  [DictWeekDateType.workday]: '工作日',
  [DictWeekDateType.weekend]: '周末'
};

// 是否支持ETC支付
export enum DictETCType {
  yes = '01',
  no = '02'
}
export const dictETCMap: {
  [key: string]: string;
} = {
  [DictETCType.yes]: '支持',
  [DictETCType.no]: '不支持'
};
//岗亭状态
export enum SentryStatusMode {
  Forbidden = '00',
  StartUsing = '01'
}
export const sentryStatusModeMap: {
  [key: string]: string;
} = {
  [SentryStatusMode.Forbidden]: '禁用',
  [SentryStatusMode.StartUsing]: '启用'
};

export enum SentryMode {
  Normal = '00',
  Center = '01',
  Move = '02'
}
export const sentryModeMap: {
  [key: string]: string;
} = {
  [SentryMode.Normal]: '普通岗亭',
  [SentryMode.Center]: '中央岗亭',
  [SentryMode.Move]: '移动岗亭'
};
//操作模块
export enum OptionMode {
  A = '001',
  B = '002',
  C = '003',
  D = '004',
  E = '005',
  F = '006'
}
export const optionModeMap: {
  [key: string]: string;
} = {
  [OptionMode.A]: '区域信息',
  [OptionMode.B]: '车场信息',
  [OptionMode.C]: '通道信息',
  [OptionMode.D]: '设备信息',
  [OptionMode.E]: '岗亭信息',
  [OptionMode.F]: '岗亭人员管理'
};
//下发状态
export enum SendStatus {
  error = '00',
  success = '01',
  sending = '02',
  noSend = '03'
}
export const sendStatusMap: {
  [key: string]: string;
} = {
  [SendStatus.error]: '下发失败',
  [SendStatus.success]: '下发成功',
  [SendStatus.sending]: '下发中',
  [SendStatus.noSend]: '无需下发'
};

// 车场类型
export enum eventTypeStatus {
  yardConnect = '00',
  yardOffLine = '01',
  equipmentConnect = '02',
  equipmentOffLine = '03',
  equipmentFault = '04'
}
export const eventTypeMap: {
  [key: string]: string;
} = {
  [eventTypeStatus.yardConnect]: '车场连接',
  [eventTypeStatus.yardOffLine]: '车场离线',
  [eventTypeStatus.equipmentConnect]: '设备连接',
  [eventTypeStatus.equipmentOffLine]: '设备离线',
  [eventTypeStatus.equipmentFault]: '设备故障'
};
// 运营类型 01：开发商委托 02：业委会委托 03：小业主委托 04：自有停车场
export enum typesOperators {
  error = '01',
  success = '02',
  sending = '03',
  noSend = '04'
}
export const typesOperatorsMap: {
  [key: string]: string;
} = {
  [typesOperators.error]: '开发商委托',
  [typesOperators.success]: '业委会委托',
  [typesOperators.sending]: '小业主委托',
  [typesOperators.noSend]: '自有停车场'
};
// 项目属性 01：酬金制 02：包干制
export enum detailProperty {
  error = '1',
  success = '2'
  // error = '01',
  // success = '02',
}
export const detailPropertyMap: {
  [key: string]: string;
} = {
  [detailProperty.error]: '酬金制',
  [detailProperty.success]: '包干制'
};
//月卡退费方式 00 无需审批 01 收费系统审批
export enum RefundMethod {
  no = '00',
  yes = '01'
}
export const refundMethodMap: {
  [key: string]: string;
} = {
  [RefundMethod.no]: '无需审批',
  [RefundMethod.yes]: '收费系统审批'
};
